import { render, staticRenderFns } from "./MultiTab.vue?vue&type=template&id=2daa63c6&scoped=true&"
import script from "./MultiTab.vue?vue&type=script&lang=ts&"
export * from "./MultiTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa63c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2daa63c6')) {
      api.createRecord('2daa63c6', component.options)
    } else {
      api.reload('2daa63c6', component.options)
    }
    module.hot.accept("./MultiTab.vue?vue&type=template&id=2daa63c6&scoped=true&", function () {
      api.rerender('2daa63c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/admin/components/MultiTab.vue"
export default component.exports